import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useRoute } from 'vue-router/composables';
import { storeToRefs } from 'pinia';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { useStartPageJwtvExperiment } from '@/components/experiments/startPageJwtv';


export default /*#__PURE__*/_defineComponent({
  __name: 'NavJwtvItem',
  setup(__props) {

const { webLocale, country } = storeToRefs(useLanguageStore());
const route = useRoute();

const jwtvPath = computed(() =>
	country.value === 'GB'
		? { name: 'app.titles.popular.provider', params: { provider: 'justwatchtv' } }
		: { name: 'app.jwtv.landing-page', path: `/${webLocale.value}/watch` }
);

const isActive = computed(() => route.name === 'app.jwtv.landing-page');

const { activeVariant: startPageJwtvVariant } = useStartPageJwtvExperiment();

function handleClick() {
	TrackingHelper.trackEvent(
		'userinteraction',
		{ action: 'tabchange', label: 'jwtv', useLastRoute: true },
		[],
		false,
		true
	);
}

return { __sfc: true,webLocale, country, route, jwtvPath, isActive, startPageJwtvVariant, handleClick }
}

})